import React, { useMemo } from 'react'
import injectSheet from 'react-jss'
import styles from './slide-footer.styles'
import classNames from 'classnames'
import debounce from 'lodash/debounce'
import { Formik } from 'formik'
import FormTextArea from 'pobble-components/dist/form-elements/form-text-area'
import { useSubscriptionPolicy } from 'pobble-components/dist/subscriptions'

const PUBLIC_LABEL =
  'Add your notes to this slide (people can see this if you share the lesson)'
const PRIVATE_LABEL = 'Add private notes to this slide (only you can see these)'

const SlideFooter = ({
  classes,
  className,
  onSubmit,
  privateNote,
  publicNote
}) => {
  const debounceChange = useMemo(
    () => debounce(submitForm => submitForm(), 500),
    []
  )
  const editSp = useSubscriptionPolicy(
    sp => sp.lesson_planning.edit_presentation
  )

  return (
    <Formik
      onSubmit={onSubmit}
      initialValues={{
        privateNote: privateNote || '',
        publicNote: publicNote || ''
      }}>
      {({ handleSubmit, handleChange, handleBlur, values, submitForm }) => (
        <form onSubmit={handleSubmit}>
          <div className={classNames(classes.container, className)}>
            {editSp.restricted && (
              <div
                onClick={editSp.showDialog}
                className={classes.restrictOverlay}
              />
            )}
            <div className={classes.labelsContainer}>
              <div className={classes.cell}>
                <label
                  title={PUBLIC_LABEL}
                  className={classes.label}
                  htmlFor="public-notes">
                  {PUBLIC_LABEL}
                </label>
              </div>
              <div className={classes.cell}>
                <label
                  title={PRIVATE_LABEL}
                  className={classes.label}
                  htmlFor="public-notes">
                  {PRIVATE_LABEL}
                </label>
              </div>
            </div>
            <div className={classes.textareasContainer}>
              <div className={classes.cell}>
                <FormTextArea
                  id="public-notes"
                  name="publicNote"
                  value={values.publicNote}
                  onChange={e => {
                    handleChange(e)
                    debounceChange(submitForm)
                  }}
                  onBlur={handleBlur}
                  className={classNames(classes.notes, classes.publicNote)}
                />
              </div>
              <div className={classes.cell}>
                <FormTextArea
                  name="privateNote"
                  value={values.privateNote}
                  onChange={e => {
                    handleChange(e)
                    debounceChange(submitForm)
                  }}
                  onBlur={handleBlur}
                  className={classNames(classes.notes, classes.privateNote)}
                  id="public-notes"
                />
              </div>
            </div>
          </div>
        </form>
      )}
    </Formik>
  )
}

export default injectSheet(styles)(SlideFooter)
